var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortReversed = function SvgSortReversed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "sort-arrow"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3020_5047",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3020_5047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_upward_alt",
    d: "M11.2513 10.8751L9.58464 12.5417C9.43186 12.6945 9.25477 12.7709 9.05339 12.7709C8.852 12.7709 8.67491 12.6945 8.52214 12.5417C8.36936 12.389 8.29297 12.2119 8.29297 12.0105C8.29297 11.8091 8.36936 11.632 8.52214 11.4792L11.4805 8.52091C11.6332 8.36814 11.8069 8.29175 12.0013 8.29175C12.1957 8.29175 12.3694 8.36814 12.5221 8.52091L15.4805 11.4792C15.6332 11.632 15.7096 11.8056 15.7096 12.0001C15.7096 12.1945 15.6332 12.3681 15.4805 12.5209C15.3277 12.6737 15.1506 12.7501 14.9492 12.7501C14.7478 12.7501 14.5707 12.6737 14.418 12.5209L12.7513 10.8751V16.2501C12.7513 16.4584 12.6784 16.6355 12.5326 16.7813C12.3867 16.9272 12.2096 17.0001 12.0013 17.0001C11.793 17.0001 11.6159 16.9272 11.4701 16.7813C11.3242 16.6355 11.2513 16.4584 11.2513 16.2501V10.8751Z",
    fill: "#33445E"
  })))));
};
export default SvgSortReversed;